import _ from 'underscore';
import queryString from 'query-string';
import stringify from 'json-stable-stringify';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  EstimateTaxesResult,
  EstimateTaxesVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<EstimateTaxesVariables, null>) {
  const { variables } = params;

  const {
    locator,
    totalAmount,
    isTaxIncluded,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid, aid } = descriptor;

  const search = {
    uid,
    cid,
    accountId: aid,
    totalAmount,
    isTaxIncluded,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Billing/EstimateTaxesAllPayments${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<EstimateTaxesVariables, null>({
  schema,
  dataPath: 'user:customer:account:estimate_taxes',
  verb: requestVerbs.GET,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract<
  EstimateTaxesVariables,
  null,
  EstimateTaxesResult,
  EstimateTaxesResult[],
  EstimateTaxesResult[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: estimateTaxes => stringify(estimateTaxes),
  processorFn: response => response,
});
